import { render, staticRenderFns } from "./paperdetail.vue?vue&type=template&id=9ee52032&scoped=true"
import script from "./paperdetail.vue?vue&type=script&lang=js"
export * from "./paperdetail.vue?vue&type=script&lang=js"
import style0 from "./paperdetail.vue?vue&type=style&index=0&id=9ee52032&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ee52032",
  null
  
)

export default component.exports